import React, { useState } from "react";
import { ThemeProvider } from "styled-components";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import { darkTheme, lightTheme } from './utils/Themes.js';
import MainLayout from "./layouts/MainLayout";
import HomePage from "./pages/HomePage";
import ExperiencePage from "./pages/ExperiencePage";
import ProjectsPage from "./pages/ProjectsPage";
import EducationPage from "./pages/EducationPage";
import ScrollToTop from "./ScrollToTop";
import ContactPage from "./pages/ContactPage";

function ScreensaverPage() {
  return (
    <iframe
      src="/public/screensaver/index.html"
      style={{ width: "100vw", height: "100vh", border: "none" }}
      title="Screensaver"
    />
  );
}

function App() {
  const [darkMode] = useState(true);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/experience" element={<ExperiencePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
          <Route path="/screensaver" element={<ScreensaverPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
